import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ResponsiveService } from '../responsive.service';
import { CommonService } from '../common.service';

gsap.registerPlugin(ScrollTrigger);
gsap.config({
  force3D: true,
});

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})

export class SplashScreenComponent implements OnInit, AfterViewInit {

  splashTimeline:any;
  logoAI: any;

  constructor(
    private _router:Router,
    private _responsive:ResponsiveService,
    private _commonService: CommonService,
    private zone: NgZone
  ) { }

  ngOnInit(): void { 
    if(!this._responsive.isHybrid()) {
      if(this._commonService.findtag('action')) {
        this._router.navigate(['onboarding', 'process-shell', 'rcob', this._commonService.findtag('action')],{
          queryParamsHandling: 'preserve',
        });
      }
      else this._router.navigate(['onboarding', 'process-shell', 'rcob', 'applicant-info']);
    }
    this.setupSplashAnimation();
  }

  ngAfterViewInit(){
    if(this._responsive.isHybrid()) {
      (<any>window).navigator.splashscreen.hide();
      this.startSplashAnimation();
    }
  }

  setupSplashAnimation(){
    this.logoAI = gsap.timeline({
      paused: true,
      ease: "power3.inOut",
      smoothChildTiming: false,
      delay: 1000/1000.0
    });

    this.logoAI.eventCallback("onComplete", () => {
      this.onAnimationComplete();
    });

    this.logoAI.fromTo("#logoPart1", { css: {opacity: 0} }, { css: {opacity:1}, immediateRender: true, duration: 0.5 }, 0);
    this.logoAI.fromTo("#logoPart2", { css: {opacity: 0} }, { css: {opacity:1}, immediateRender: true, duration: 0.5 }, 0);

    this.logoAI.fromTo("#splashLogo", { css: {left: 112} }, { css: {left: 0 }, delay: 0.5, duration: 0.5 }, 1);
    this.logoAI.fromTo("#splashLogoText", { css: {opacity: 0} }, { css: {opacity: 1 }, delay: 0.5, duration: 1.0 }, 2);
  }

  startSplashAnimation(){
    this.logoAI.play();
    setTimeout(()=>{
      this.onAnimationComplete();
    }, 5000);
  }

  onAnimationComplete(){
      console.log('splash');
      this.zone.run(() => {
        this._router.navigate(['login']);
      });
  }

}
